/**
 * Currencies Repository
 * Handles business logic for fetching currencies
 */

import { CurrenciesApi } from './currencies-api';
import { CurrencyItem } from '../types/currencies-types';

export class CurrenciesRepository {
  constructor(private api: CurrenciesApi) {}

  /**
   * Get available currencies (hardcoded list)
   */
  async getAvailableCurrencies(): Promise<CurrencyItem[]> {
    return this.api.getCurrencies();
  }
}
